<template>
  <div class="expertregister">
    <van-nav-bar title="专家认证" v-if="nextNum==1 || nextNum==2" left-arrow @click-left="onClickLeft" fixed/>
    <van-nav-bar title="专家认证" right-text="跳过" v-if="nextNum==3" left-arrow @click-left="onClickLeft" @click-right="onClickRight" fixed/>
    <div class="expertregister-line line-height"></div>
    <div class="steps-box">
      <div class="steps-box-tip">专家认证步骤</div>
      <div class="steps-box-list">
        <div class="steps-flex">
          <img class="icon-img" v-if="nextNum==1" src="../assets/expertregisterimg/icon-2.png">
          <img class="icon-img" v-if="nextNum==2 || nextNum==3" src="../assets/expertregisterimg/icon-1.png">
          <p class="icon-1">基本信息</p>
        </div>
        <div class="steps-line-1 steps-line-3"></div>
        <div class="steps-flex">
          <img class="icon-img" v-if="nextNum==1" src="../assets/expertregisterimg/icon-3.png">
          <img class="icon-img" v-if="nextNum==2" src="../assets/expertregisterimg/icon-2.png">
          <img class="icon-img" v-if="nextNum==3" src="../assets/expertregisterimg/icon-1.png">
          <p :class="nextNum==2 || nextNum==3 ? 'icon-1':''">执业信息</p>
        </div>
        <div class="steps-line-2" :class="nextNum==3 ? 'steps-line-3':''"></div>
        <div class="steps-flex">
          <img class="icon-img" v-if="nextNum==2 || nextNum==1" src="../assets/expertregisterimg/icon-3.png">
          <img class="icon-img" v-if="nextNum==3" src="../assets/expertregisterimg/icon-2.png">
          <p :class="nextNum==3 ? 'icon-1':''">当前信息</p>
        </div>
      </div>
    </div>
    <div class="expertregister-line"></div>

    <div class="expertregister-real" v-if="nextNum==1">
      <div class="real-title">
        <i>★</i>
        <span>真实姓名</span>
      </div>
      <div class="real-input">
        <van-field v-model="expertForm.user_name" maxlength="20" placeholder="请输入用户名" />
      </div>
      <div class="real-text">需填写真实姓名</div>
      <div class="real-title">
        <i>★</i>
        <span>身份证号码</span>
      </div>
      <div class="real-input">
        <van-field v-model="expertForm.id_card" placeholder="请输入真实身份证号码" />
      </div>
      <div class="real-text">为保证用户权益，专家身份需进行实名认证，方便服务费用支 取等信息核对。</div>
    </div>

    <div class="expertregister-practice" v-if="nextNum==2">
      <div class="real-title">
        <i>★</i>
        <span>所属专业领域（可多选）</span>
      </div>
      <van-checkbox-group class="expertregister-major-checkbox" v-model="radio1" @change="getRadio1">
        <van-checkbox :name="item.et_id" v-for="(item,i) in expertType" :key="i">
          <template #icon="props">
            <div :class="props.checked ? 'activeIcon' : 'inactiveIcon'">{{item.et_name}}</div>
          </template>
        </van-checkbox>
      </van-checkbox-group>
      <div class="real-title">
        <i>★</i>
        <span>职称</span>
      </div>
      <div class="real-input">
        <van-field :disabled="true" v-model="titleValue" right-icon="arrow-down" placeholder="请选择您的职称" @click="show1 = true"/>
      </div>
      <div class="real-title">
        <i>★</i>
        <span>擅长种类</span>
      </div>
      <van-checkbox-group class="expertregister-class-checkbox" v-model="radio2" @change="getRadio2" direction="horizontal">
        <van-checkbox shape="square" :name="item.class_id" v-for="(item,i) in animal" :key="i">{{item.class_name}}</van-checkbox>
      </van-checkbox-group>
      <div class="real-title">
        <i>★</i>
        <span>上传资质证明</span>
      </div>
      <div class="imglist" v-for="(item,i) in imgList" :key="i">
        <img :src="item" alt="图片" class="uploadimg">
        <van-icon name="delete-o" @click="delImg(i)" class="delte"/>
      </div>
      <van-uploader
        v-show="imgList.length<5"
        :max-count="5" 
        accept="image/jpeg, image/png, image/jpg, application/msword"
        :max-size="2 * 1024 * 1024"
        @oversize="onOversize"
        :after-read="afterRead"
      />
      <div class="practice-text">该证明为坐诊专家凭证，如：<span>兽医资格证、学位证、毕业证、工作证明等</span>，暂无可之后进行上传。最多上传<span>5</span>张。</div>
    </div>

    <div class="expertregister-state" v-if="nextNum==3">
      <div class="real-title">
        <span>参加工作年份</span>
      </div>
      <div class="real-input">
        <van-field :disabled="true" readonly v-model="expertForm.service_begin_year" right-icon="arrow-down" placeholder="请选择参加工作年份" @click="show2 = true"/>
      </div>
      <div class="real-title">
        <span>现任职单位</span>
      </div>
      <div class="real-input">
        <van-field v-model="expertForm.company_name" placeholder="请输入现任职单位"/>
      </div>
      <div class="real-title">
        <span>职务</span>
      </div>
      <div class="real-input">
        <van-field v-model="expertForm.post" placeholder="请输入您的职务"/>
      </div>
      <div class="expertregister-switch">
        <div class="switch-box">
          <div class="switch-left">服务定位</div>
          <div class="switch-right">
            <van-switch :value="checked" @input="onInput"/>
          </div>
        </div>
        <div class="" v-show="checked">
          <div class="real-title">
            <i>★</i>
            <span class="title">所在地区</span>
          </div>
          <div class="real-input">
            <van-field v-model="fieldValue" readonly right-icon="arrow-down" placeholder="请选择省市区" @click="show = true"/>
          </div>
          <div class="real-title">
            
            <i>★</i>
            <span class="title">详细地址</span>
          </div>
          <div class="real-input">
            <van-field v-model="expertForm.address" placeholder="请输入详细地址" />
          </div>
        </div>
        <div class="switch-text">
          <span>温馨提示：</span>
          <p>1、填写详细地址后更快获得养殖户精准咨询。</p>
          <p>2、您的地址信息仅用于地图找专家功能使用。</p>
          <p>3、您可以通过关闭地图找专家功能，停止对您的位置展示。</p>
        </div>
      </div>
    </div>
    <div class="expertregister-line" v-if="nextNum==3"></div>
    <div class="expertregister-state state-padding-top" v-if="nextNum==3">
      <div class="real-title">
        <span>专业特长/学术成就</span>
      </div>
      <div class="real-input">
        <van-field v-model="expertForm.skills" rows="3" autosize type="textarea" placeholder="请输入专业特长/学术成就"/>
      </div>
      <!-- <div class="real-title">
        <span>教育背景</span>
      </div>
      <div class="real-input">
        <van-field v-model="expertForm.education" rows="3" autosize type="textarea" placeholder="请输入您的教育背景信息"/>
      </div>
      <div class="real-title">
        <span>工作简介</span>
      </div>
      <div class="real-input">
        <van-field v-model="expertForm.career" rows="3" autosize type="textarea" placeholder="请输入您的工作经历信息"/>
      </div> -->
    </div>

    <div class="next-practice-button" v-if="nextNum==1">
      <van-button round size="large" :disabled="expertForm.user_name !=='' && expertForm.id_card !== '' ? false : true" @click="nextPractice">下一步</van-button>
    </div>

    <div class="next-practice-button" v-if="nextNum==2">
      <van-button round size="large" :disabled="imgList.length > 0 && radio2.length > 0 && radio1   .length > 0 && titleValue !== '' ? false : true" @click="nextState">下一步</van-button>
    </div>

    <div class="next-practice-button" v-if="nextNum==3">
      <van-button round size="large" @click="expertInfo">提交</van-button>
    </div>

    <van-popup v-model="show" round position="bottom">
      <van-area :area-list="areaList" @confirm="addressArea" @cancel="close"/>
    </van-popup>
    <van-action-sheet v-model="show1" title="选择职称">
      <div class="content">
        <van-radio-group v-model="radio" @change="getRadio">
          <div class="">
            <van-radio :name="item.pt_id" v-for="(item,i) in expertList[0]" :key="i">
              <template #icon="props">
                <div :class="props.checked ? 'activeIcon' : 'inactiveIcon'">{{item.pt_name}}</div>
              </template>
            </van-radio>
          </div>
          <div class="">
            <van-radio :name="item.pt_id" v-for="(item,i) in expertList[1]" :key="i">
              <template #icon="props">
                <div :class="props.checked ? 'activeIcon' : 'inactiveIcon'">{{item.pt_name}}</div>
              </template>
            </van-radio>
          </div>
          <div class="">
            <van-radio :name="item.pt_id" v-for="(item,i) in expertList[2]" :key="i">
              <template #icon="props">
                <div :class="props.checked ? 'activeIcon' : 'inactiveIcon'">{{item.pt_name}}</div>
              </template>
            </van-radio>
          </div>
          <div class="">
            <van-radio :name="item.pt_id" v-for="(item,i) in expertList[3]" :key="i">
              <template #icon="props">
                <div :class="props.checked ? 'activeIcon' : 'inactiveIcon'">{{item.pt_name}}</div>
              </template>
            </van-radio>
          </div>
          <div class="">
            <van-radio :name="item.pt_id" v-for="(item,i) in expertList[4]" :key="i">
              <template #icon="props">
                <div :class="props.checked ? 'activeIcon' : 'inactiveIcon'">{{item.pt_name}}</div>
              </template>
            </van-radio>
          </div>
          <div class="">
            <van-radio :name="item.pt_id" v-for="(item,i) in expertList[5]" :key="i">
              <template #icon="props">
                <div :class="props.checked ? 'activeIcon' : 'inactiveIcon'">{{item.pt_name}}</div>
              </template>
            </van-radio>
          </div>
        </van-radio-group>
      </div>
    </van-action-sheet>
    <van-popup v-model="show2" round position="bottom">
      <van-picker
        title="选择年份"
        show-toolbar
        :columns="columns"
        @confirm="onConfirm"
        @cancel="onCancel"
      />
    </van-popup>

    <!-- <van-checkbox-group v-model="radio2" @change="getRadio2">
      <van-checkbox :name="item.class_id" v-for="(item,i) in animal" :key="i">
        <template #icon="props">
          <div :class="props.checked ? 'activeIcon' : 'inactiveIcon'">{{item.class_name}}</div>
        </template>
      </van-checkbox>
    </van-checkbox-group> -->

  </div>
</template>

<script>
  import OSS from 'ali-oss'
  import { Toast,Dialog } from 'vant'
  import { mapGetters } from 'vuex'
  import { areaList } from '@vant/area-data';
  import { wechaturl } from '@/api/path.js'
  import { wxshare  } from '@/utils/utils.js'
  import { getUserType,updateexpertinfo } from '@/api/resetApi.js'
  export default {
    name: 'expertregister',
    data() {
      return {
        nextNum: 1,
        isNext: true,
        expertForm: {
          
          token: localStorage.getItem('eToken'),
          user_id: localStorage.getItem('userId'),
          user_name: '',
          id_card: '',
          service_begin_year: '',
          post: '',
          expert_type: '',
          positional_title: '',
          class_id: '',
          company_name: '',
          skills: '',
          province: '',
          city: '',
          county: '',
          address: '',
          show_in_map: 0,
          prove_uri: [],
          career: '',
          education: '',
          group_unit: '',
        },
        city: '',
        titleValue: '',
        fieldValue: '',
        getApp: '',
        checked: false,
        active: 0,
        urls: '',
        imgList: [],
        show: false,
        show1: false,
        show2: false,
        show3: false,
        areaList,
        columns: [],
        radio: '',
        radio1: [],
        radio2: [],
        animal: [],
        expertType: [],
        expertList: [],
        img: 'https://zkjy.oss-cn-beijing.aliyuncs.com/2021/share/expertregister.png',
        title: '立即申请，成为中科名兽医平台共享专家。',
        desc: '诚邀全国畜牧业相关专家，在线提供及时、便捷、高效的专业化服务。',
        wechaturl: wechaturl,
        url: wechaturl+'expertlogin',
      }
    },
    computed: {
      ...mapGetters([
        'expertUserName',
        'expertToken',
        'expertUserId'
      ]),
    },
    created(){
      console.log('userName',this.expertUserName)
      console.log('userId',this.expertUserId)
      console.log('expertToken',this.expertToken)
      this.getApp = this.$route.query.h5
      this.getInitYear()
      this.configoss()
      this.getUserType()
      wxshare(this.img,this.title,this.desc,this.url)
    },
    methods: {
      closeViews () {
        this.$toast('退出程序')
      },
      // 返回
      onClickLeft() {
        if (this.nextNum == 1) {
          // this.$router.back(-1)
          this.$router.replace('/authentication?page=1')
        } else if (this.nextNum == 2) {
          this.nextNum = 1
        } else if (this.nextNum == 3) {
          this.nextNum = 2
        }
      },
      // 进入执业信息
      nextPractice() {
        let regname =  /^([\u4e00-\u9fa5a-zA-Z]){1,20}$/
        let reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
        if (!regname.test(this.expertForm.user_name)) {
          Toast.fail('姓名必须是中文或英文字母');
        } else if (!reg.test(this.expertForm.id_card)) {
          Toast.fail('请输入正确身份证号码');
        } else {
          this.nextNum = 2
        }
      },
      // 进入当前状态
      nextState() {
        this.nextNum = 3
      },
      delImg(idx) {
        this.imgList.splice(idx,1)
        console.log('idx',idx)
        console.log('this.imgList',this.imgList)
      },
      //
      onInput(checked) {
        this.checked = checked;
        if (this.checked) {
          this.expertForm.show_in_map = 1
        } else {
          this.expertForm.show_in_map = 0
          this.fieldValue = ''
          this.expertForm.province = ''
          this.expertForm.county = ''
          this.expertForm.city = ''
          this.expertForm.address = ''
        }
      },
      // 选择擅长种类
      getRadio2() {
        console.log('radio2',this.radio2)
      },
      // 选择专业领域
      getRadio1() {
        console.log('radio1',this.radio1)
      },
      // 选择职称
      getRadio() {
        console.log('radio',this.radio)
        for (let i=0;i<this.expertList.length;i++) {
          for (let j=0;j<this.expertList[i].length;j++) {
            if (this.radio == this.expertList[i][j].pt_id) {
              this.titleValue = this.expertList[i][j].pt_name
              this.expertForm.positional_title = this.expertList[i][j].pt_id
              console.log('this.titleValue',this.titleValue)
              console.log('positional_title',this.expertForm.positional_title)
              this.show1 = false
              return
            }
          }
        }
      },
      // 初始化年份
      getInitYear() {
        let myYear = [];
        for (let i=70;i<=new Date().getYear();i++){
          var now = 1900 + i;
          myYear.push(now)
        }
        this.columns = myYear.reverse()
        console.log('myYear',this.columns)
      },
      onCancel() {
        this.expertForm.service_begin_year = ''
        this.show2 = false
      },
      onConfirm(val) {
        this.expertForm.service_begin_year = val
        console.log('val',val)
        this.show2 = false
      },
      // 专家初始信息
      async getUserType() {
        const res = await getUserType()
        console.log(res)
        try {
          if (res.data.code == 1) {
            this.animal = res.data.obj.animal
            this.expertType = res.data.obj.et
            this.expertList = res.data.obj.pt_list
            console.log('this.expertType',this.expertType)
          }
        } catch (error) {}
      },
      // 关闭省市区
      close() {
        this.fieldValue = ''
        this.expertForm.province = ''
        this.expertForm.city = ''
        this.expertForm.county = ''
        this.show = false
      },
      // 省市区
      addressArea(val) {
        this.expertForm.province = val[0].name
        this.city = val[1].name
        if (val[0].name == val[1].name) {
          this.expertForm.city = '市辖区'
        } else {
          this.expertForm.city = val[1].name
        }
        this.expertForm.county = val[2].name
        this.fieldValue = this.expertForm.province + '/' + this.city + '/' + this.expertForm.county
        this.show = false
        console.log('val=',val)
      },
      //初始化oss
      configoss() {
        this.client = new OSS({
          region: 'oss-cn-beijing', //地区
          accessKeyId:'LTAI01SbNvZ4Balm',
          //accessKeyId: 'LTAIY713pjruaMYc', //申请的osskey
          accessKeySecret: 'SBbyg3HEPSAJRZP4t4GTRR7STA8jGk',
          //accessKeySecret: 'ju2c4XhXWDZrtKypFrInwk8ZSI2dO8', //申请的osssecret
          bucket: 'zkjy', //oss应用名
          dirPath: 'oss/document/manager-cont/cont/', //oss 文件夹 不存在会自动创建
        })
      },
      // 上传图片组件
      onOversize() {
        Toast.fail('请上传大小≤2M的文件');
      },
      afterRead(file) {
        Toast.loading({
          duration: 5, // 持续展示 toast
          forbidClick: true,
          message: '上传中',
        });
        if (file.length) { //判断是否选择了多个文件，如果是的话，循环遍历单个文件上传
          file.forEach((f) => {
            this.uploadFile(f);
          });
        } else {
          this.uploadFile(file);
        }
      },
      uploadFile(e) {
        let file = e.file;
        let pos = file.name.lastIndexOf('.');
        let imageKey = `${file.name.substring(0, pos)}-${new Date().getTime()}`
        console.log('imageKey',imageKey)

        this.client.multipartUpload('/oss/document/manager-cont/images/' + imageKey,file).then(resp => {
          Toast.clear();
          let {res} = resp
          this.urls = res.requestUrls[0]
          if(this.urls.indexOf("?") != -1){
            this.urls = this.urls.split("?")[0];
          }
          if (this.urls) {
            this.imgList.push(this.urls);    
            console.log('urls',this.imgList)        
            Toast.success('上传成功！');
          } else {
            Toast.fail('上传失败');
          }
        }).catch(err => {})
      },
      // 提交所有资料
      expertInfo() {
        if (this.checked) {
          if (!this.fieldValue) {
            Toast('请选择地区')
          } else if (!this.expertForm.address) {
            Toast('请输入详细地址')
          } else {
            console.log('expertForm=',this.expertForm)
            this.updateexpertinfo()
          }
        } else {
          console.log('expertForm=',this.expertForm)
          this.updateexpertinfo()
        }
      },
      onClickRight() {
        if (this.checked) {
          if (!this.fieldValue) {
            Toast('请选择地区')
          } else if (!this.expertForm.address) {
            Toast('请输入详细地址')
          } else {
            console.log('expertForm=',this.expertForm)
            Dialog.confirm({
              title: '温馨提示',
              message: '当前信息页面跳过后，可通过App中“注册为专家”进行修改',
              confirmButtonColor: '#127BE4',
            }).then(() => {
              console.log('确定')
              this.updateexpertinfo()
            }).catch(() => {
              Toast('取消跳过')
            });
          }
        } else {
          console.log('expertForm=',this.expertForm)
          Dialog.confirm({
            title: '温馨提示',
            message: '当前信息页面跳过后，可通过App中“注册为专家”进行修改',
            confirmButtonColor: '#127BE4',
          }).then(() => {
            console.log('确定')
            this.updateexpertinfo()
          }).catch(() => {
            Toast('取消跳过')
          });
        }
      },
      async updateexpertinfo() {
        // this.expertForm.token = this.expertToken
        // this.expertForm.user_id = this.expertUserId
        this.expertForm.prove_uri = this.imgList.join(",")
        this.expertForm.class_id = this.radio2.join(",")
        this.expertForm.expert_type = this.radio1.join(",")
        const formData = new FormData();
        //循环传入的值转换formData
        Object.keys(this.expertForm).forEach((key) => {
          formData.append(key, this.expertForm[key]);
        })
        const res = await updateexpertinfo(formData)
        console.log(res)
        try {
          if (res.data.code == 1) {
            Toast.success('提交成功');
            // this.$router.push({
            //   name: 'expertregistersuccess',
            //   query:{
            //     state: 1
            //   }
            // })
            this.$router.replace('/expertregistersuccess?state=1')
          } else {
            Toast.fail(res.data.msg);
          }
        } catch (error) {}
      },
    },
  }
</script>

<style lang="scss">
  .expertregister {
    max-width: 3.8rem;
    margin: 0 auto;
  }
  .van-nav-bar--fixed {
    position: fixed;
    top: 0;
    left: 50%;
    margin-left: -1.9rem;
    width: 3.8rem;
  }
  .van-checkbox__label {
    line-height: 0.2rem;
  }
  .expertregister {
    font-size: 0;
    text-align: left;
    .expertregister-line {
      width: 100%;
      height: 0.1rem;
      background: #F5F5F5;
    }
    .line-height {
      padding-top: 0.43rem;
    }
    .steps-box {
      padding-top: 0.15rem;
      text-align: center;
      .steps-box-tip {
        display: inline-block;
        width: 1.2rem;
        height: 0.2rem;
        line-height: 0.2rem;
        background: #eff6ff;
        border-radius: 0.1rem;
        font-size: 0.12rem;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: bold;
        text-align: center;
        color: #127be4;
      }
      .steps-box-list {
        position: relative;
        display: flex;
        padding: 0.15rem 0;
        .steps-flex {
          flex: 1;
          .icon-img {
            width: 0.3rem;
            height: 0.3rem;
          }
          p {
            padding-top: 0.05rem;
            font-size: 0.12rem;
            font-family: PingFangSC, PingFangSC-Regular;
            font-weight: 500;
            text-align: center;
            color: #999999;
          }
          .icon-1 {
            font-weight: bold;
            color: #333;
          }
        }
        .steps-line-1 {
          position: absolute;
          top: 0.3rem;
          left: 20%;
          width: 1rem;
          height: 0.01rem;
          background: #d8d8d8;
        }
        .steps-line-2 {
          position: absolute;
          top: 0.3rem;
          right: 20%;
          width: 1rem;
          height: 0.01rem;
          background: #d8d8d8;
        }
        .steps-line-3 {
          background: #127be4;
        }
      }
    }
    .expertregister-real {
      padding: 0.15rem;
      .expertregister .van-radio-group {
        padding: 0;
      }
    }
    .real-title {
      vertical-align: middle;
      padding: 0.15rem 0;
      i {
        vertical-align: middle;
        font-size: 0.1rem;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: right;
        color: #ff8062;
      }
      span {
        vertical-align: middle;
        margin-left: 0.05rem;
        font-size: 0.14rem;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: bold;
        text-align: left;
        color: #333333;
      }
      .title {
        font-size: 0.12rem;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: left;
        color: #333333;
      }
    }
    .real-input {
      .van-cell {
        background: #f5f5f5;
        border-radius: 0.08rem;
      }
      .van-field__control:disabled {
        color: #969799;
        -webkit-text-fill-color: #969799;
      }
    }
    .real-text {
      padding-top: 0.1rem;
      line-height: 0.15rem;
      font-size: 0.12rem;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: 400;
      text-align: left;
      color: #999999;
    }
    .expertregister-practice {
      padding: 0.15rem 0.15rem 1rem;
      font-size: 0.12rem;
      .van-uploader__upload {
        width: 1rem;
        height: 0.6rem;
      }
    }
    .expertregister-major-checkbox {
      .van-checkbox {
        display: inline-block;
        height: 0.4rem;
      }
    }
    .expertregister-class-checkbox {
      .van-checkbox-group {
        padding: 0;
      }
      .van-checkbox--horizontal {
        margin-bottom: 0.15rem;
        margin-right: 0.1rem;
      }
    }
    .next-practice-button {
      position: fixed;
      bottom: 0;
      left: 50%;
      margin-left: -1.9rem;
      width: 3.4rem;
      font-size: 0;
      padding: 0.1rem 0.2rem 0.3rem;
      background: #fff;
      .van-button--default {
        background-color: #127BE4;
        color: #fff;
      }
    }
    .practice-text {
      padding: 0.1rem 0;
      font-size: 0.12rem;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: 400;
      text-align: left;
      line-height: 0.15rem;
      color: #666666;
      span {
        color: #FF716E;
      }
    }
    .content {
      padding: 0.1rem 0;
      font-size: 0.1rem;
      color: #333;
      .van-radio-group {
        padding: 0.1rem 0.15rem;
      }
      .van-radio {
        display: inline-block;
        height: 0.38rem;
      }
    }
    .inactiveIcon {
      display: inline-block;
      margin: 0.05rem;
      width: 1rem;
      height: 0.3rem;
      line-height: 0.3rem;
      border: 0.01rem solid #f1f1f1;
      text-align: center;
      font-size: 0.12rem;
    }
    .activeIcon {
      display: inline-block;
      margin: 0.05rem;
      width: 1rem;
      height: 0.3rem;
      line-height: 0.3rem;
      border: 0.01rem solid #0186ff;
      background: #E7F1FC;
      text-align: center;
      font-size: 0.12rem;
      color: #0186ff;
    }
    .van-uploader {
      display: inline-block;
      vertical-align: top;
      margin-right: 0.1rem;
    }
    .imglist {
      display: inline-block;
      position: relative;
      margin: 0 0.1rem 0.08rem 0;
      width: 1rem;
      height: 0.6rem;
      .uploadimg {
        width: 1rem;
        height: 0.6rem;
      }
      .delte {
        position: absolute;
        right: 0.04rem;
        bottom: 0.04rem;
        width: 0.1rem;
        height: 0.1rem;
        font-size: 0.14rem;
        color: rgb(46, 43, 43);
      }
    }
    .expertregister-state {
      padding: 0.15rem;
      font-size: 0.12rem;
    }
    .state-padding-top {
      padding: 0 0.15rem 1.2rem 0.15rem;
    }
    .expertregister-switch {
      .switch-box {
        display: flex;
        padding: 0.15rem 0 0.1rem;
        border-bottom: 1px solid #eeeeee;
        .switch-left {
          flex: 1;
          align-self: center;
          font-size: 0.14rem;
          font-family: PingFangSC, PingFangSC-Medium;
          font-weight: bold;
          text-align: justify;
          color: #181818;
        }
        .switch-right {
          flex: 0 0 0.38rem;
          align-self: center;
          .van-switch {
            position: relative;
            display: inline-block;
            box-sizing: content-box;
            width: 0.38rem;
            height: 0.22rem;
            font-size: 30px;
            background-color: #f2f2f2;
            border: 0;
            // border: 0.01rem solid #f2f2f2;
          }
          .van-switch__node {
            position: absolute;
            top: 0;
            left: 0;
            width: 0.2rem;
            height: 0.2rem;
          }
          .van-switch--on {
            background-color: #34C759;
          }
          .van-switch--on .van-switch__node {
            -webkit-transform: translateX(0.18rem);
            transform: translateX(0.18rem);
          }
        }
      }
      .switch-text {
        padding: 0.15rem 0.05rem 0;
        font-size: 0.12rem;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: left;
        color: #666666;
        span {
          display: inline-block;
          padding-bottom: 0.05rem;
          font-weight: bold;
        }
        p {
          padding-top: 0.06rem;
          font-size: 0.1rem;
          color: #999999;
        }
      }
    }
    
    // .van-checkbox {
    //   display: inline-block;
    //   width: 0.6rem;
    //   height: 0.4rem;
    //   font-size: 12px;
    // }
  }
</style>